import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useSessionStore from '../store/sessionStore'
import Button from '../components/ui/Button'
import Card from '../components/ui/Card'
import styles from './LinkInput.module.css'

export default function LinkInput() {
  const navigate = useNavigate()
  const setVerifLink = useSessionStore((s) => s.setVerifLink)
  const [url, setUrl] = useState('')
  const [error, setError] = useState('')

  const handleContinue = () => {
    setError('')
    if (url.trim()) {
      try {
        new URL(url)
        setVerifLink(url.trim())
      } catch {
        setError('Please enter a valid URL, or skip this step.')
        return
      }
    }
    navigate('/select-type')
  }

  const handleSkip = () => {
    setVerifLink(null)
    navigate('/select-type')
  }

  return (
    <main className={styles.main}>
      <div className={styles.container}>
        <h1 className={styles.title}>Verification link</h1>
        <p className={styles.sub}>
          Paste the link to the verification service you need to complete.
        </p>
        <Card padding="lg" className={styles.card}>
          <label htmlFor="verif-url" className={styles.label}>
            Verification service URL (optional)
          </label>
          <input
            id="verif-url"
            type="url"
            value={url}
            onChange={(e) => {
              setUrl(e.target.value)
              setError('')
            }}
            placeholder="https://..."
            className={styles.input}
            aria-describedby={error ? 'url-error' : 'url-helper'}
          />
          {error && (
            <p id="url-error" className={styles.error} role="alert">
              {error}
            </p>
          )}
          <p id="url-helper" className={styles.helper}>
            For example a banking app verification page or KYC service link
          </p>
          <div className={styles.actions}>
            <Button variant="ghost" onClick={handleSkip}>
              Skip
            </Button>
            <Button onClick={handleContinue}>Continue</Button>
          </div>
        </Card>
      </div>
    </main>
  )
}
